
export default {
  vessel: {
    search: {
      padding: 'sm',
      borderBottomWidth: 1,
      backgroundColor: 'grey-lighter'
    }
  },
  data() {
    return {
      showSearch: false,
      langSwitcher: false
    }
  },
  computed: {
    links() {
      return [
        { label: 'pages.home', route: 'index' },
        { label: 'pages.villa', route: 'the-villa' },
        { label: 'pages.location', route: 'location' },
        { label: 'pages.gallery', route: 'photo-gallery' },
        { label: 'pages.contact', route: 'contact' }
      ]
    },
    mobileLinks() {
      return [
        { label: 'pages.home', route: 'index' },
        { label: 'pages.villa', route: 'the-villa' },
        { label: 'pages.location', route: 'location' },
        { label: 'pages.gallery', route: 'photo-gallery' },
        { label: 'pages.facilities', route: 'facilities-rules' },
        { label: 'pages.contact', route: 'contact' }
      ]
    }
  },
  methods: {
    toggleSearch() {
      this.showSearch = !this.showSearch

      if (this.showSearch && this.$refs.searchInput) {
        this.$nextTick(() => {
          this.$refs.searchInput.focusInput()
        })
      }
    }
  }
}
